export default __webpack_public_path__ + "static/media/icon-checkmark-circle.aa657946.svg";